module.exports = __webpack_public_path__ + "media/site/images/icons/gold-arrow-icon-a6965f2c992bdede50a757e4a7de2476.svg";